
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useOrderService from '../../../app/services/hooks/useOrderService';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { Society } from '../../../app/models/Society';
import { Client } from '../../../app/models/Client';
import { PaymentCondition } from '../../../app/models/PaymentCondition';
import { Currency } from '../../../app/models/Currency';
import {
    defaultWarehouseOrderDataForm,
    WarehouseOrderDataForm
} from '../../../app/models/WarehouseOrder';
import LazyLoading from '../../../components/LazyLoading';
import DefaultCard from '../../../components/default/DefaultCard';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCreatedModifiedUserForm from '../../../components/default/DefaultCreatedModifiedUserForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { toast } from 'react-toastify';
import WarehouseOrderForm from '../components/forms/WarehouseOrderForm';
import { Quote, QuoteDataForm, QuoteReferenceDataForm } from '../../../app/models/Quote';
import { RouterParams } from '../../../app/shared/interfaces';
import { Unit } from '../../../app/models/Unit';
import { Roles, WarehouseOrderStatuses } from '../../../app/shared/enums';
import { AuthContext } from '../../../contexts/AuthContext';
import useSweetAlert from '../../../hooks/useSweetAlert';
import useClientService from '../../../app/services/hooks/useClientService';
import { WarehouseOrderStatus } from '../../../app/models/WarehouseOrderStatus';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { Tab, Tabs } from 'react-bootstrap';
import useQuoteInvoicingService from '../../../app/services/hooks/useQuoteInvoicingService';
import { ExchangeRateDate } from '../../../app/models/ExchangeRateDate';
import { WarehouseQuoteDetail } from '../../../app/models/WareHouseQuoteDetail';
import WarehouseOrderShowForm from '../components/forms/WarehouseOrderShowForm';
import { TransportationOrderInvoicingShowDataForm } from '../../../app/models/TransportationOrderInvoicing';
import useWarehouseOrderService from '../../../app/services/hooks/useWarehouseOrderService';
import WarehouseQuoteRatesContainer from '../../Quotes/subpages/WareHouseQuote/components/containers/WareHouseRatesContainer';
import WarehouseOrderItemsContainer from '../components/WarehouseOrderItemsContainer';
import WarehouseOrderChangeStatusEdit from '../components/WarehouseOrderChangeStatusEdit';
import useWarehouseOrderInvoicingService from '../../../app/services/hooks/useWarehouseOrderInvoicingService';
import WarehouseOrderInvoicingShowForm from '../components/forms/WarehouseOrderInvoicingForm';
import WarehouseOrderStorageContainer from '../components/containers/WareHouseOrderStorageContainer';
import WarehouseOrderRatesContainer from '../components/containers/WareHouseOrderRatesContainer';
import WarehouseOrderExtraServiceContainer from '../components/containers/WareHouseOrderExtraServicesContainer';
import WarehouseOrderExpeditionContainer from '../components/containers/WareHouseOrderExpeditionContainer';

const WarehouseOrderEdit = () => {

    const { showLoading, hideLoading } = useContext(AppContext);
    const { id } = useParams<RouterParams>();
    const location = useLocation();
    const isUnifiedMode = location.pathname.startsWith('/pedidos/');

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Pedidos',
            url: '/pedidos',
            isActive: false
        },
        {
            name: 'Editar pedido #' + id,
            url: (isUnifiedMode ? '/pedidos/' : '/warehouse-orders/') + id + '/edit',
            isActive: true
        }
    ];

    const { auth } = useContext(AuthContext);

    const {
        editWarehouseOrder,
        fetchingEditWarehouseOrder,
        fetchingShowWarehouseOrder,
        updateWarehouseOrder,
        showWarehouseOrder,
        showQuoteWarehouseOrder,
        updateWarehouseOrderRateRunner,
        canChangeStatusWarehouseOrder,
        fetchingCanChangeStatusWarehouseOrder,
        changeStatusWarehouseOrder,
        fetchingChangeStatusWarehouseOrder
    } = useWarehouseOrderService();

    const { editUnifiedOrder, canChangeStatusUnifiedOrder, changeStatusUnifiedOrder } = useOrderService();

  
    const {
        getClientsBySociety,
        fetchingGetClientBySociety
    } = useClientService();

    const { 
        editQuoteInvoicing,
        getQuoteInvoicingByQuote,
        updateQuoteInvoicing, 
        fetchingQuoteInvoicingByQuote,
        fetchingUpdateQuoteInvoicing
    } = useQuoteInvoicingService();

    const {
        fetchingWarehouseOrderInvoicingByWarehouseOrder,
        editWarehouseOrderInvoicing,
        getWarehouseOrderInvoicingByWarehouseOrder
    } = useWarehouseOrderInvoicingService();

    const [warehouseOrderForm, setWarehouseOrderForm] =
        useState<WarehouseOrderDataForm>(defaultWarehouseOrderDataForm);
    const [orderId, setOrderId] = useState<number | undefined>(undefined);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const [errorFields, setErrorFields] = useState<any>();
    const [canBeEdited, setCanBeEdited] = useState(false);

    const [quotes, setQuotes] = useState<WarehouseQuoteDetail[]>([]);
    const [quotesId, setQuotesId] = useState<number>();
    const [clients, setClients] = useState<Client[]>([]);
    const [societies, setSocieties] = useState<Society[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);
    const [paymentConditions, setPaymentsConditions] = useState<PaymentCondition[]>([]);
    const [paymentMethods, setPaymentMethods] = useState<PaymentCondition[]>([]);
    const [references, setReferences] = useState<QuoteReferenceDataForm[]>([]);
    const [disabledRunner, setDisabledRunner] = useState<boolean>(false);
    const warehouseOrderFromTqd = useRef<WarehouseOrderDataForm|undefined>();
    const clientsFromTqd = useRef<Client[]>([]);
    const societyIdSelected = useRef<number | undefined>(0);
    const quoteId = useRef<number | undefined>(0);
    const [statuses, setStatuses] = useState<WarehouseOrderStatus[]>([]);
    const [exchangeRateDate, setExchangeRateDate] = useState<ExchangeRateDate[]>([]);
    const [warehouseOrderInvoicingForm, setWarehouseOrderInvoicingInvoicingForm] = useState<TransportationOrderInvoicingShowDataForm>({});
    const [refreshKey, setRefreshKey] = useState(0);
    
    
    useEffect(() => {
        reloadModule();
    }, [id]);




    const edit = (id: number) => {
        setCanBeEdited(false);
        const editFn = isUnifiedMode ? editUnifiedOrder : editWarehouseOrder;
        editFn(id, {
            onSuccess: (response: ServiceResponse) => {
                if (
                    response.data.warehouse_order.warehouse_quote_detail_id == '' ||
                    response.data.warehouse_order.warehouse_quote_detail_id == null
                ) {
                    setCanBeEdited(true);
                }

                setSocieties(response.data.societies);
                setClients(response.data.clients);
                setPaymentMethods(response.data.payment_methods);
                setPaymentsConditions(response.data.payment_conditions);
                setCurrencies(response.data.currencies);
                setQuantityUnits(response.data.quantity_units);
                setQuotes(response.data.quotes);
                // setQuotesId(response.data.quote.id);
                setReferences(response.data.references);
                setExchangeRateDate(response.data.exchange_rate_date ?? []);
                setStatuses(response.data.statuses);
                societyIdSelected.current = response.data.warehouse_order.society_id;
                setWarehouseOrderForm(response.data.warehouse_order);
                setWarehouseOrderInvoicingInvoicingForm(response.data.invoicing);
                if (response.data.order_id) setOrderId(response.data.order_id);
                setIsLoaded(true);

                if(response.data.warehouse_order.warehouse_quote_detail_id){

                    clientsFromTqd.current = response.data.clients;
                    warehouseOrderFromTqd.current = response.data.warehouse_order;
                // const quoteId = response.data.warehouse_order.quote_id;

                // getQuoteInvoicingByQuote(Number(quoteId), 'view', {
                //     onSuccess: (response: ServiceResponse) => {
                //     },
                // });
            }
                
            }
        });
    };

    useEffect(() => {

        if (warehouseOrderForm.society_id == undefined) {
            societyIdSelected.current = undefined;
        }

        if (warehouseOrderForm.society_id && warehouseOrderForm.society_id != societyIdSelected.current) {

            if((warehouseOrderFromTqd.current && 
                warehouseOrderFromTqd.current.warehouse_quote_detail_id &&
                warehouseOrderFromTqd.current.society_id != warehouseOrderForm.society_id) ||
                (!warehouseOrderFromTqd.current)
            ){

                    getClientsBySociety(Number(warehouseOrderForm.society_id), {
                        onSuccess: (response: ServiceResponse) => {
                            societyIdSelected.current = Number(warehouseOrderForm.society_id) ?? 0;
                            
                            setClients(response.data.clients);
                            setWarehouseOrderForm(
                                {
                                    ...warehouseOrderForm,
                                    client_id: 0
                                }
                            )
                        },
                        onError: (response: ServiceResponse) => {
                            setWarehouseOrderForm({
                                ...warehouseOrderForm,
                                society_id: Number(societyIdSelected.current)
                            });
                        }
                    })
                    
                }
            else if(
                (warehouseOrderFromTqd.current && 
                    warehouseOrderFromTqd.current.warehouse_quote_detail_id &&
                    warehouseOrderFromTqd.current.society_id == warehouseOrderForm.society_id)
            ){
                societyIdSelected.current = Number(warehouseOrderForm.society_id) ?? 0;
                setClients(clientsFromTqd.current);
                setWarehouseOrderForm(
                    {
                        ...warehouseOrderForm,
                        client_id: warehouseOrderFromTqd.current.client_id
                    }
                )

            }
             
        }
     
    }, [warehouseOrderForm.society_id]);

    const updateRateRunner = () => {
        useSweetAlert().spinnerAlert('Actualizando tarifas...');
        updateWarehouseOrderRateRunner(warehouseOrderForm.id!, warehouseOrderForm, {
            onSuccess: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.success(response.message);
                setErrorFields(undefined);
                reloadModule();
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setErrorFields(errorFields.data);
            }
        });
    };

    const reloadModule = () => {
        edit(parseInt(id));
        getInvoicing(parseInt(id));
        // show(parseInt(id));
    };


    const requestChangeStatus = (status: string) => {
        if (showLoading) showLoading('loading', 'Cargando...');
        const canChangeFn = isUnifiedMode && orderId
            ? (statusArg: string, events: any) => canChangeStatusUnifiedOrder(orderId, statusArg, events)
            : (statusArg: string, events: any) => canChangeStatusWarehouseOrder(parseInt(id), statusArg, events);
        canChangeFn(status, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                changeStatus(status, response.message);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message,
                    message_list: response.data?.message_list ?? []
                });
                toast.error(response.message);
            }
        });
    };

    const changeStatus = (status: string, message: string) => {
        let _text = `Está a punto de cambiar el estado del pedido de almacenamiento #${id}.${message ?? ''}`;

        if(status === WarehouseOrderStatuses.ANULADO){
            _text = "Está a punto de anular el pedido de almacenamiento, este cambiará a estado Activo"
        }
        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Sí, cambiar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Cambiando estado...');
                        const changeFn = isUnifiedMode && orderId
                            ? (statusArg: string, events: any) => changeStatusUnifiedOrder(orderId, statusArg, events)
                            : (statusArg: string, events: any) => changeStatusWarehouseOrder(Number(id), statusArg, events);
                        changeFn(status, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();
                                reloadModule();
                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();
                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message,
                                    message_list: response.data?.message_list ?? []
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El pedido de almacenamiento no ha cambiado de estado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };


    const getInvoicing = (id: number) => {
            // getWarehouseOrderInvoicingByWarehouseOrder(Number(id),'view', {
            //     onSuccess: (response: ServiceResponse) => {
            //         setWarehouseOrderInvoicingInvoicingForm(response.data.quote_invoicing);
            //     },
            //     onError: (response: ServiceResponse) => 
            //         {
            //         toast.info(response.message);
            //     }
            // });;

                // editQuoteInvoicing(id, {
                //     onSuccess: (response: ServiceResponse) => {
                //     const data = response?.data;
                //     if (data) {
            
                //         setPaymentsConditions(response.data.payment_conditions);
                //         setPaymentMethods(response.data.payment_methods);
                //         setCurrencies(response.data.currencies);
                //         setWarehouseOrderInvoicingInvoicingForm(response.data.quote_invoicing);

                //     }
                //     }
                // });

                // if (id) {
                // getQuoteInvoicingByQuote(quotes?.id, 'edit', {
                //         onSuccess: (response: ServiceResponse) => {
                //             setWarehouseOrderInvoicingInvoicingForm(response.data.quote_invoicing);
                //         },
                //     });
                // }
        };
    

    return (
        <>
            <Breadcrumbs
                pageSection={`Editar pedido #${id}`}
                breadcrumbs={breadcrumbs}
            />

               <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                    <Tab eventKey="general-data" title="Datos Generales">
                        <div className="row">
                            <div className="col-md-6">
                                <DefaultCard>
                                    <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                                    {isLoaded && !fetchingEditWarehouseOrder ? (
                                        // canBeEdited ? (
                                        //     <>
                                        //         <WarehouseOrderForm
                                        //             warehouseOrderForm={warehouseOrderForm}
                                        //             setWarehouseOrderForm={setWarehouseOrderForm}
                                        //             societies={societies}
                                        //             clients={clients}
                                        //             paymentConditions={paymentConditions}
                                        //             paymentMethods={paymentMethods}
                                        //             quantityUnits={quantityUnits}
                                        //             currencies={currencies}
                                        //             errorFields={errorFields}
                                        //             quotes={quotes}
                                        //         />
                                        //         <div className="row justify-content-end">
                                        //             <div className="col-auto">
                                        //                 <ButtonSaveForm callbackSave={update} />
                                        //             </div>
                                        //         </div>
                                        //     </>
                                        // ) : (
                                        <>
                                            <WarehouseOrderShowForm
                                                warehouseOrderDataForm={warehouseOrderForm}
                                                quotes={quotes}
                                            />
                                        </>
                                    ) : (
                                        // )
                                        <LazyLoading />
                                    )}
                                </DefaultCard>
                            </div>
                            <div className="col-md-6">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                                        {isLoaded && !fetchingEditWarehouseOrder ? (
                                            canBeEdited ? (
                                                <>
                                                    <DefaultCreatedModifiedUserForm
                                                        createdBy={warehouseOrderForm.created_user}
                                                        createdAt={warehouseOrderForm.created_at}
                                                        updatedBy={warehouseOrderForm.last_modified_user}
                                                        updatedAt={warehouseOrderForm.updated_at}
                                                        status={warehouseOrderForm.status}
                                                    />
                                                </>
                                            ) : (
                                                <DefaultCreatedModifiedUserForm
                                                    createdBy={warehouseOrderForm.created_user}
                                                    createdAt={warehouseOrderForm.created_at}
                                                    updatedBy={warehouseOrderForm.last_modified_user}
                                                    updatedAt={warehouseOrderForm.updated_at}
                                                    status={warehouseOrderForm.status}
                                                    // status={
                                                    //     warehouseOrderForm.status_selected
                                                    //         ? warehouseOrderForm.status_selected.name.toString()
                                                    //         : ''
                                                    // }
                                                />
                                            )
                                        ) : (
                                            <LazyLoading />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Tab>


                    <Tab eventKey="invoicing" title="Facturación">
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">Facturación</div>
                                {!fetchingWarehouseOrderInvoicingByWarehouseOrder ? (

                                <>
                                    <WarehouseOrderInvoicingShowForm
                                        warehouseOrderInvoicingDataForm={warehouseOrderInvoicingForm}
                                        setWarehouseOrderInvoicingDataForm={setWarehouseOrderInvoicingInvoicingForm}
                                        orderId={orderId ?? parseInt(id)}
                                        paymentMethods={paymentMethods}
                                        references={references}
                                        exchangeRateDate={exchangeRateDate}
                                        onSaved={reloadModule}
                                    />
                                </>
                            ) : (
                                <LazyLoading />
                             )}
                        </DefaultCard>
                    </Tab>

                    <Tab eventKey="storage" title="Almacenamiento">
                            <WarehouseOrderStorageContainer 
                                warehouseOrderId={parseInt(id) ?? 0} 
                                disableUpdate={true} 
                                refresh={refreshKey}
                            />
                    </Tab>
                    <Tab eventKey="expedition" title="Expedición">
                        {/* <WarehouseQuoteExpeditionContainer quoteId={id} disableUpdate={disableUpdate}  /> */}
                            <WarehouseOrderExpeditionContainer 
                                warehouseOrderId={parseInt(id) ?? 0} 
                                disableUpdate={false} 
                                refresh={refreshKey}
                            />
                    </Tab>
                    <Tab eventKey="extras" title="Servicios Adicionales">
                            <WarehouseOrderExtraServiceContainer 
                                warehouseOrderId={parseInt(id)?? 0} 
                                disableUpdate={false} 
                                refresh={refreshKey}
                            />
                       
                    </Tab>
                    <Tab eventKey="rates" title="Tarifas del servicio">
                            <WarehouseOrderRatesContainer 
                                warehouseOrderId={parseInt(id) ?? 0} 
                                disableUpdate={true} 
                                refresh={refreshKey}
                            />
                        {/* <WarehouseQuoteRatesContainer quoteId={id} disableUpdate={disableUpdate} refresh={refreshKey} /> */}
                    </Tab>
                    </Tabs>

                    {isLoaded && !fetchingEditWarehouseOrder && !fetchingShowWarehouseOrder ? (
                        <>
                            <WarehouseOrderItemsContainer
                                warehouseOrderId={parseInt(id)}
                                orderId={orderId}
                                canBeEdited={canBeEdited}
                                currencyId={warehouseOrderForm.currency_id}
                                warehouseOrderForm={warehouseOrderForm}
                                setWarehouseOrderForm={setWarehouseOrderForm}
                                reloadModule={reloadModule}
                            />
                            <WarehouseOrderChangeStatusEdit
                                status={String(warehouseOrderForm?.status)}
                                statuses={statuses}
                                requestChangeStatus={requestChangeStatus}
                                fetchingChangeStatus={fetchingChangeStatusWarehouseOrder}
                            />
                        </>
                    ) : null}
                </>
    );
};

export default WarehouseOrderEdit;
